module.exports = __webpack_public_path__ + "img/code.b8834027.jpg";